import React, { useState, useMemo } from "react";
import { Box } from "@mui/material";
import { VaultCard, VaultCardUI } from "../atoms/VaultCard";
import { BaseModalComponent } from "../../../common/BaseModalComponent";
import DetailsCardVault from "./DetailsCardVault";
import VerificationModal from "./VerificationModal";
import { useModals } from "../../../../context/ModalContext";

const VaultItem: React.FC<any> = ({
  card,
  unlocked,
  passwordDisplay,
  secretDetail,
  onDelete,
  onUpdate,
  vaultRemainingSeconds,
  isPreviewMode,
}) => {
  const { openModal, closeModal } = useModals();
  const [isTemporarilyVerified, setIsTemporarilyVerified] = useState(false);

  const detailModalKey = useMemo(() => `detail-${card.id}`, [card.id]);
  const verifyModalKey = useMemo(() => `verify-${card.id}`, [card.id]);

  const isHighSecurity = card.highSecurity && !isTemporarilyVerified;

  if (!unlocked) {
    return (
      <Box sx={{ width: "100%", opacity: 0.45, filter: "grayscale(1)", pointerEvents: "none" }}>
        <VaultCard card={card} passwordDisplay={passwordDisplay} />
      </Box>
    );
  }

  // MODO NORMAL O YA VERIFICADO

  return (
    <BaseModalComponent
      modalKey={detailModalKey}
      elementTrigger={

        <Box sx={{ width: "100%" }}>
          <VaultCard card={card} passwordDisplay={passwordDisplay} />
        </Box>}

      defaultSizes={{
        width: { xs: "95%", sm: "80%", md: "900px" },
        height: { xs: "95%", sm: "90%", md: "90%" },
      }}

    >
      <DetailsCardVault secretId={card.id} secret={secretDetail} unlocked={unlocked}
        onDelete={onDelete}
        onUpdate={onUpdate}
        modalKey={detailModalKey}
        closeOnSave
        vaultRemainingSeconds={vaultRemainingSeconds}
        isPreviewMode={isPreviewMode}
      />
    </BaseModalComponent>


  );
};

export default VaultItem;